import axios from 'axios'
import Cookie from 'js-cookie'
import apiAuth from './methods/auth'
import apiQuestionnaire from './methods/questionnaire'
import apiDoctor from './methods/doctor'
import apiQuestion from './methods/question'
import apiUsers from './methods/users'
import apiDepartments from './methods/departments'
import apiProcedure from './methods/procedure'
import apiProcedureType from './methods/procedureType'
import apiStatistics from './methods/statistics'
import apiPush from './methods/push'
// import apiLog from './methods/log'

export default {
  removeJWT () {
    Cookie.remove('access_token')
    Cookie.remove('refresh_token')
  },

  resetJWT (responseData) {
    const tokenExpires = responseData.expires_at
    Cookie.set('access_token', responseData.access_token)

    const d = new Date(tokenExpires)
    Cookie.set('expires_token', d.toUTCString())
  },

  clean (obj) {
    for (const propName in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (!obj.hasOwnProperty(propName)) continue
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName]
      }
    }
  },

  trimCookie (cookie) {
    return cookie ? cookie.replace(/[А-Яа-я]/ig, '') : ''
  },

  setupInstance (store, router) {
    this.apiInstance = axios.create({
      baseURL: process.env.VUE_APP_ADMIN_API_BASE_URL,
      headers: {
        common: {
          Access: 'application/json',
          'Accept-Language': 'ru',
          'X-Requested-With': 'XMLHttpRequest',
          'access-control-allow-origin': '*'
        }
      },
      mode: 'cors'
    })

    this.apiInstance.interceptors.request.use(async config => {
      if (Cookie.get('expires_token')) {
        const nowDate = new Date()
        const exDate = new Date(Cookie.get('expires_token'))

        if (nowDate >= exDate && router.history.current.name !== 'auth.signin') {
          if (config.url !== '/auth/refresh') {
            await store.dispatch('auth/REFRESH_TOKEN')
          }
        }
      }

      if (config.method === 'put' || config.method === 'post') {
        this.clean(config.data)
      }
      if (Cookie.get('access_token')) {
        config.headers.common.Authorization = `Bearer ${this.trimCookie(Cookie.get('access_token'))}`
      }
      return config
    }, async error => {
      return Promise.reject(error)
    })

    this.apiInstance.interceptors.response.use(async response => {
      return response
    }, async (error) => {
      let code = 0
      if (error.response) {
        code = error.response.status
      }

      if (code === 401 && router.history.current.name !== 'auth.signin') {
        if (error.response.config.url === '/auth/refresh') {
          await store.dispatch('auth/LOGOUT')
          router.push({
            name: 'auth.signin'
          })
        } else {
          await store.dispatch('auth/REFRESH_TOKEN')
        }
      }

      return Promise.reject(error)
    })
  },

  install (Vue, store, router) {
    this.app = Vue.prototype
    this.setupInstance(store, router)

    const repositories = {
      auth: apiAuth(this.apiInstance),
      users: apiUsers(this.apiInstance),
      questionnaire: apiQuestionnaire(this.apiInstance),
      doctor: apiDoctor(this.apiInstance),
      question: apiQuestion(this.apiInstance),
      departments: apiDepartments(this.apiInstance),
      procedure: apiProcedure(this.apiInstance),
      procedureType: apiProcedureType(this.apiInstance),
      statistics: apiStatistics(this.apiInstance),
      push: apiPush(this.apiInstance)
    }

    Vue.prototype.$api = repositories
    Vue.prototype.$apiInstance = this.apiInstance
    store.$api = repositories
    store.resetJWT = this.resetJWT
    store.removeJWT = this.removeJWT
  }
}
